import React from 'react';
import ACardsGrid from '../../components/ACardGrid/ACardGrid';
import { useHistory } from 'react-router-dom';
import { useGetPermissions } from '../../layouts/customHook';
import { ReactComponent as DocumentIcon } from "assets/img/svg/Document.svg"

const StudentTransferRequestCards = ({
    setShowTransferRequestsList
}) => {

    const history = useHistory();

    const bulkTransferPermissions = useGetPermissions("studentTransferRequestBulk");
    const bulkPaymentTransferPermissions = useGetPermissions("bulkPaymentTransfer");

    const cardsInfo = [
        {
            heading: 'Transfer Tracker',
            subHeading: 'Visit this page to View Submitted Transfer Request',
            Icon: () => <DocumentIcon />,
            onNextClick: () => setShowTransferRequestsList(true)
        },
        bulkTransferPermissions && {
            heading: 'Bulk Transfer',
            subHeading: 'Generate Transfer Request in Bulk',
            Icon: () => <DocumentIcon />,
            onNextClick: () => history.push("/admin/studentTransferRequestBulk")
        },
        bulkPaymentTransferPermissions && {
            heading: 'Other Charge Transfer ',
            subHeading: 'Transfer Other Charge Payment in bulk',
            Icon: () => <DocumentIcon />,
            onNextClick: () => history.push("/admin/bulkPaymentTransfer")
        }
    ]

    return (
        <ACardsGrid cardsInfo={cardsInfo} className='mt-3' />
    );
}


export default StudentTransferRequestCards;